import styled from "styled-components";

export const ReportTree = styled.div`
  min-width: 500px;

  > ul {
    background: rgba(228, 228, 228, 0.15);
    border: solid 1px #e7e7e7;
    border-radius: 4px;
    padding: 22px 19.2px 9px 21px;
    margin-top: 2px;
  }
  
`;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/SwitchReport/style.js